import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [
  LIST_PROJECT_FILES,
  LIST_PROJECT_FILES_SUCCESS,
  LIST_PROJECT_FILES_FAILURE,
] = createRequestActionTypes('tech/LIST_PROJECT_FILES');

export const listProjectFiles = createAction(
  LIST_PROJECT_FILES,
  (fileTyp, fileAttrVal1) => ({ fileTyp, fileAttrVal1 }),
);
const listProjectFilesSaga = createRequestSaga(
  LIST_PROJECT_FILES,
  chanceApi.getChanceFiles,
);

const UNLOAD_FILES = 'tech/UNLOAD_FILES';
export const unloadFiles = createAction(UNLOAD_FILES);

export function* projectFilesSaga() {
  yield takeLatest(LIST_PROJECT_FILES, listProjectFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const projectFiles = handleActions(
  {
    [LIST_PROJECT_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUrl: file.fileUrl,
        fileTyp: file.fileTyp,
        fileAttrVal1: file.fileAttrVal1, //prjUuid
        fileAttrVal2: file.fileAttrVal2,
        fileAttrVal3: file.fileAttrVal3,
        fileNm: file.fileNm,
        fileDesc: file.fileDesc,
        crtNm: file.crtNm,
        crtDt: file.crtDt,
        cngNm: file.cngNm,
        cngDt: file.cngDt,
      })),
      error: null,
    }),
    [LIST_PROJECT_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_FILES]: () => initialState,
  },
  initialState,
);

export default projectFiles;
